import React from 'react';
import { FileText } from 'lucide-react';

const RecalcResults = ({ recalcResult }) => {
  if (!recalcResult) return null;

  return (
    <div className="bg-slate-800/50 rounded-2xl border border-slate-700 p-6">
      <h3 className="text-white font-semibold mb-4 flex items-center gap-2">
        <FileText className="w-5 h-5 text-blue-400" />
        Compliance Recalculation Results
      </h3>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
        <div className="p-3 bg-slate-700/50 rounded-lg">
          <p className="text-slate-400 text-xs">Days Recalculated</p>
          <p className="text-white text-lg font-semibold">{recalcResult.days_recalculated}</p>
        </div>
        <div className="p-3 bg-slate-700/50 rounded-lg">
          <p className="text-slate-400 text-xs">Segments Analyzed</p>
          <p className="text-white text-lg font-semibold">{recalcResult.segments_analyzed}</p>
        </div>
        <div className="p-3 bg-emerald-500/20 rounded-lg">
          <p className="text-emerald-400 text-xs">Violations Resolved</p>
          <p className="text-white text-lg font-semibold">{recalcResult.violations_resolved}</p>
        </div>
        <div className="p-3 bg-red-500/20 rounded-lg">
          <p className="text-red-400 text-xs">New Violations</p>
          <p className="text-white text-lg font-semibold">{recalcResult.violations_found}</p>
        </div>
      </div>

      <p className="text-slate-400 text-sm">
        Period: {new Date(recalcResult.from_date).toLocaleDateString()} to {new Date(recalcResult.to_date).toLocaleDateString()}
      </p>
    </div>
  );
};

export default RecalcResults;
